import DispatchServices from "@/services/DispatchServices.js";

export default {
  getDispatchList: DispatchServices.getList
}